import React, { useState, useEffect } from 'react'
import api, { MetadataOption } from 'api'
import { Select } from 'antd'
import './AppFormItem.less'

export interface AppSelectProps {
	value?: string
	onChange?: (value: any, text: string) => void
	placeholder?: string
	readonly?: boolean
	options?: MetadataOption[]
}

const getText = (value?: string, options?: MetadataOption[]) => {
	let option = options.find(o => o.value === value) || { label: '' }
	return option.label || ''
}

export const AppSelect = (props: AppSelectProps) => {
	const [value, setValue] = useState(props.value)

	const handleChang = (newValue: string) => {
		props.onChange && props.onChange(newValue, getText(newValue, props.options))
		setValue(newValue)
	}

	return (
		<div style={{ width: '100%' }} className="app-select">
			<Select
				placeholder={props.placeholder || ''}
				defaultValue={props.value}
				onChange={handleChang}
				style={{ width: '100%' }}
			>
				{props.options &&
					props.options.map((option: MetadataOption) => {
						return (
							<Select.Option key={option.value} value={option.value}>
								{option.label}
							</Select.Option>
						)
					})}
			</Select>
		</div>
	)
}



// WEBPACK FOOTER //
// ./src/components/AppFormItem/AppSelect.tsx